<template>
  <div v-if="item.type === 'paragraph' && item.header" class="offer mb-5">
    {{ item.title }}
  </div>

  <p v-else-if="item.type === 'paragraph'">
    {{ item.title }}
  </p>

  <hr v-else-if="item.type === 'divider'">

  <StarRating v-else-if="item.type === 'stars'" @on-change-score="onInput({ item: { key: 'score' }, val: $event })" :texts="item.options || {}" />

  <div v-else-if="item.type === 'submit'" class="form-actions">
    <button
      type="submit"
      class='btn btn-block btn-lg btn-primary'
      :disabled="!feedback.score || isProcessing || isLocked">
      <div v-if="isProcessing">
        <b-spinner small type="grow" />
        Loading...
      </div>
      <template v-else>{{ item.title }}</template>
    </button>
  </div>

  <div v-else-if="item.type === 'no_contact'" class="form-group mt-1">
    <label for="phone">{{ item.phone || 'Phone' }}</label>
    <input
      id="phone"
      type="text"
      placeholder=" "
      class="form-control"
      @input="onInput({ item: { key: 'phone' }, val: $event.target.value })">

    <label for="email" class="mt-3">{{ item.email || 'Email' }}</label>
    <input
      id="email"
      type="text"
      placeholder=" "
      class="form-control"
      @input="onInput({ item: { key: 'email' }, val: $event.target.value })">
  </div>

  <p v-else-if="item.type === 'review_links'" class="mt-1">
    {{ item.textPre }} <a href="#" @click.prevent="onForceShowLinks">{{ item.textLink }}</a> {{ item.textAfter }}
  </p>

  <VideoInput v-else-if="item.type === 'video'" :item="item" class="mt-1"
    :errors="videoErrors"
    @on-lock="handleLockState"
    @input="onVideoInput" />

  <div v-else-if="item.type === 'copy_button'">
    <button
      v-if="feedbackGatheringEnabled"
      type="button"
      class="btn btn-block btn-lg mb-4"
      :style="{ backgroundColor: item.bgColor, color: item.txtColor }"
      @click.prevent="onCopy">
      {{ item.title }}
    </button>
  </div>

  <div v-else class="form-group mt-1">
    <label :for="item.key">
      {{ item.title }}
      <span v-if="item.required" class="text-danger">*</span>
    </label>

    <input v-if="item.type === 'string'"
      :id="item.key"
      type="text"
      placeholder=" "
      class="form-control"
      @input="onInput({ item, val: $event.target.value })">

    <textarea v-else-if="item.type === 'text'"
      :id="item.key"
      rows="5"
      placeholder=" "
      class="form-control"
      @input="onInput({ item, val: $event.target.value })" />

    <textarea v-else-if="item.type === 'review_body'"
      :id="item.key"
      rows="5"
      placeholder=" "
      class="form-control"
      @input="onInput({ item: { key: 'body' }, val: $event.target.value })" />

    <div v-else-if="item.type === 'review_body_on_negative'">
      <textarea
        :id="item.key"
        :value="feedback.body"
        :disabled="!!feedback.body"
        rows="5"
        placeholder=" "
        class="form-control"
        @input="onInputNegativeFeedbackBody($event.target.value)" />

      <button
        :disabled="!!feedback.body"
        type="button"
        class="btn btn-block btn-lg mt-2"
        style="width: 50%;margin-left: 25%;"
        @click.prevent="onSave">
        Save
      </button>
    </div>

    <select v-else-if="item.type === 'dropdown'"
      :id="item.key"
      class="form-control"
      @change="onInput({ item, val: $event.target.value })">
      <option value disabled selected>Please Choose</option>
      <option :value="option" v-for="option in item.options" :key="option">{{ option }}</option>
    </select>

    <small
      v-if="errors.length"
      class="text-danger">
      {{ errors.join(', ') }}
    </small>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import StarRating from './star_rating'
import VideoInput from './video_input'

function copyToClipboard(txt) {
  const input = document.createElement('input')
  input.value = txt
  document.body.appendChild(input)
  input.select()
  input.setSelectionRange(0, 99999)
  document.execCommand('copy')
  input.remove()
}

function copyToClipboardWithAnimation(el, text) {
  if (!el.classList.contains('active')) {
    el.classList.add('active')
    const initialBtnLabel = el.innerText
    el.innerText = 'Copied to clipboard'
    copyToClipboard(text)
    setTimeout(() => {
      el.classList.remove('active')
      el.innerText = initialBtnLabel
    }, 1500)
  }
}

function saveWithAnimation(el) {
  if (!el.classList.contains('active')) {
    el.classList.add('active')
    const initialBtnLabel = el.innerText
    el.innerText = 'Saved'
    setTimeout(() => {
      el.classList.remove('active')
      el.innerText = initialBtnLabel
    }, 1500)
  }
}

export default {
  components: {
    StarRating,
    VideoInput,
    'b-spinner': BSpinner
  },
  props: {
    item: { type: Object, required: true },
    errors: { type: Array, default: () => []},
    videoErrors: { type: Array, default: () => []},
    isProcessing: { type: Boolean, default: false },
    isLocked: { type: Boolean, default: false },
    feedback: { type: Object },
    feedbackGatheringEnabled: { type: Boolean, required: true }
  },
  methods: {
    onInput({ item, val }) {
      this.$emit('on-change-item', { key: item.key, val })
    },
    onVideoInput(val) {
      this.$emit('on-change-item', { key: 'video', val })
    },
    onForceShowLinks() {
      this.$emit('on-force-show-links', true)
    },
    onCopy(e) {
      copyToClipboardWithAnimation(e.target, this.feedback.body || ' ')
    },
    onInputNegativeFeedbackBody(val) {
      this.$emit('on-change-negative-feedback-body', val)
    },
    onSave(e) {
      saveWithAnimation(e.target)
      this.$emit('save-negative-feedback-body')
    },
    handleLockState(state) {
      this.$emit('on-lock', state)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~stylesheets/feedback_page/variables';
@import '~stylesheets/feedback_page/form';
@import '~stylesheets/feedback_page/page';
</style>
